export const ROUTES = {
  home: '',
  login: 'auth/login',
  changePassword: 'auth/change-password',
  resetPassword: 'auth/reset-password',

  leasing: 'leasing',
  nativeMenu: 'native-menu',

  leasingRequests: 'leasing/requests',
  leasingRequestNew: 'leasing/requests/new',
  leasingRequestDetail: 'leasing/requests/:requestId',
  leasingContract: 'leasing/contract',
  leasingAppeals: 'leasing/appeals',
  leasingAppealDetail: 'leasing/appeals/:appealId',
  leasingServices: 'leasing/services',

  vehicleAssessment: 'vehicle-assessment/:appealUuid'
};
